<template>

<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg4509"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs4513"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath4523"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path4521" /></clipPath></defs><g
     id="g4515"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g4517"><g
         id="g4519"
         clip-path="url(#clipPath4523)"><g
           id="g4525"
           transform="translate(170.5029,341.335)"><path
             d="M 0,0 H 54.394 L -10.785,65.179 V 10.785 C -10.785,4.829 -5.956,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4527" /></g><g
           id="g4529"
           transform="translate(450.0664,341.335)"><path
             d="M 0,0 H 54.394 L -10.784,65.179 V 10.785 C -10.784,4.829 -5.956,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4531" /></g><g
           id="g4533"
           transform="translate(326.3642,255.418)"><path
             d="m 0,0 -60.533,38.376 c -4.302,2.729 -9.921,-0.362 -9.921,-5.456 V 16.996 c 0,-2.759 -2.235,-4.994 -4.993,-4.994 h -57.072 c -3.698,0 -6.695,-2.998 -6.695,-6.696 V -16.22 c 0,-3.698 2.997,-6.696 6.695,-6.696 h 57.072 c 2.758,0 4.993,-2.235 4.993,-4.994 v -15.924 c 0,-5.094 5.619,-8.185 9.921,-5.457 L 0,-10.914 C 4.002,-8.377 4.002,-2.537 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4535" /></g><g
           id="g4537"
           transform="translate(176.3896,202.79)"><path
             d="M 0,0 H -120.344"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4539" /></g><g
           id="g4541"
           transform="translate(176.3896,173.124)"><path
             d="M 0,0 H -120.344"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4543" /></g><g
           id="g4545"
           transform="translate(176.3896,143.457)"><path
             d="M 0,0 H -120.344"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4547" /></g><g
           id="g4549"
           transform="translate(456.4756,202.79)"><path
             d="M 0,0 H -120.345"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4551" /></g><g
           id="g4553"
           transform="translate(456.4756,173.124)"><path
             d="M 0,0 H -120.345"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4555" /></g><g
           id="g4557"
           transform="translate(456.4756,143.457)"><path
             d="M 0,0 H -120.345"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4559" /></g><g
           id="g4561"
           transform="translate(72.8779,406.5137)"><path
             d="m 0,0 h -54.554 c -5.956,0 -10.784,-4.829 -10.784,-10.785 v -279.457 c 0,-5.957 4.828,-10.785 10.784,-10.785 h 195.787 c 5.956,0 10.786,4.828 10.786,10.785 v 116.23 h -31.051 c -3.698,0 -6.696,2.998 -6.696,6.697 v 21.525 c 0,3.698 2.998,6.696 6.696,6.696 h 31.051 v 73.915 L 86.84,0 H 35"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4563" /></g><g
           id="g4565"
           transform="translate(504.4599,262.4414)"><path
             d="m 0,0 v 78.894 l -65.178,65.178 h -141.393 c -5.956,0 -10.785,-4.829 -10.785,-10.785 V 17.866 l 39.26,-24.889 c 4.002,-2.538 4.002,-8.377 0,-10.915 l -39.26,-24.89 V -146.17 c 0,-5.957 4.829,-10.785 10.785,-10.785 h 195.787 c 5.956,0 10.784,4.828 10.784,10.785 L 0,-35"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4567" /></g></g></g></g></svg>
</template>
